let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fsTi2")).then(() => parcelRequire('bMgPR'));